"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationPosition = void 0;
/**
 * Details and position information for a physical place where services are provided and resources and participants may be stored, found, contained, or accommodated.
 */
var LocationPosition = /** @class */ (function () {
    function LocationPosition() {
    }
    return LocationPosition;
}());
exports.LocationPosition = LocationPosition;
